<section class="rate-request">
    <div class="top-section">
        <h3>
            Open Cargo
        </h3>
    </div>
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <!-- <div class="alert alert-info" role="alert">
                    The rates shown in the Route Finder are estimates based on past voyages and are meant as general guidance. To get an accurate price for your specific cargo, please complete the Rate Request form. Cargo details like size, weight, and special handling needs can affect the final rate.
                  </div> -->
                <form [formGroup]="ratereqform" class="search-section-right" (ngSubmit)="onsubmit()">
                    <div class="form-group m-t-30 from-to-section">
                        <div class="row">
                            <div class="col-md-6">
                                <h4 class="main-title">
                                    From
                                </h4>
                                <div class="row m-t-30 m-r-0">
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal ">
                                            Country
                                        </label>
                                        <div class="pRel">
                                            <p-dropdown [options]="countries" [readonly]="newReadonly == true?newReadonly: readonly"
                                                optionLabel="countryName" formControlName="fromcountryid"
                                                placeholder="Select Country" [virtualScroll]="true" [filter]="false"
                                                [itemSize]="30"
                                                class="p-dropdown" (onChange)="getportbycountryid($event,'frmport')">
                                            </p-dropdown>
                                        </div>
                                        <!-- <select name="" formControlName="fromcountryid" class="form-control" id="" (change)="getportbycountryid($event,'frmport')">
                                            <option value="">--Select One--</option>              
                                            <option [value]="category.id" *ngFor="let category of countries">
                                              {{category.countryName  }}</option>                                       
                                          </select> -->

                                        <!-- <p-dropdown [options]="countries" formControlName="fromcountryid"
                                            optionLabel="countryName" class="select-dropdown-sec" placeholder="Country"
                                            [virtualScroll]="true" [itemSize]="31" [filter]="false"
                                            (onChange)="getportbycountryid($event,'frmport')"></p-dropdown> -->
                                        <div *ngIf="hasError('fromcountryid', 'required') && submitted"
                                            class="invalid-Validation">
                                            From Country is required
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Port
                                        </label>

                                        <!-- <select name="" formControlName="fromportid" class="form-control" id="">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of fromport">
                                              {{category.portName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="fromport" [readonly]="newReadonly == true?newReadonly: readonly"
                                                formControlName="fromportid" optionLabel="portName"
                                                class="select-dropdown-sec" placeholder="Port" [virtualScroll]="true"
                                                [itemSize]="31" [filter]="false">
                                            </p-dropdown>
                                        </div>

                                        <div *ngIf="hasError('fromportid', 'required') && submitted"
                                            class="invalid-Validation">
                                            From Port is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <h4 class="main-title">
                                    To
                                </h4>
                                <div class="row m-t-30 m-l-0">
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Country
                                        </label>
                                        <!-- <select name="" formControlName="tocountryid" class="form-control" id="" (change)="getportbycountryid($event,'toport')">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of countries">
                                              {{category.countryName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="countries" [readonly]="newReadonly == true?newReadonly: readonly"
                                                formControlName="tocountryid" optionLabel="countryName"
                                                class="select-dropdown-sec" placeholder="Country" [virtualScroll]="true"
                                                [itemSize]="31" [filter]="false"
                                                (onChange)="getportbycountryid($event,'toport')"></p-dropdown>
                                        </div>
                                        <div *ngIf="hasError('tocountryid', 'required') && submitted"
                                            class="invalid-Validation">
                                            To Country is required
                                        </div>
                                    </div>
                                    <div class="col-md-6 form-group">
                                        <label class="custom-labal">
                                            Port
                                        </label>
                                        <!-- <select name="" formControlName="toportid" class="form-control" id="">
                                            <option value="">--Select One--</option>
              
                                            <option [value]="category.id" *ngFor="let category of toport">
                                              {{category.portName  }}</option>                                       
                                          </select> -->
                                        <div class="pRel">
                                            <p-dropdown [options]="toport" [readonly]="newReadonly == true?newReadonly: readonly" optionLabel="portName"
                                                formControlName="toportid" class="select-dropdown-sec"
                                                placeholder="To Port" [virtualScroll]="true" [itemSize]="31"
                                                [filter]="false">
                                            </p-dropdown>
                                        </div>
                                        <div *ngIf="hasError('toportid', 'required') && submitted"
                                            class="invalid-Validation">
                                            To Port is required
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <span class="arrow arrow-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18.793" height="29.276"
                                    viewBox="0 0 19.793 20.276">
                                    <defs>
                                        <style>
                                            .a {
                                                fill: #15536b;
                                            }
                                        </style>
                                    </defs>
                                    <g transform="translate(-23.998 -87.999)">
                                        <path class="a"
                                            d="M161.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,161.447,108.275Z"
                                            transform="translate(-127.793 0)" />
                                        <path class="a"
                                            d="M25.447,108.275a1.448,1.448,0,0,1-1.024-2.472l7.665-7.665-7.665-7.665a1.448,1.448,0,0,1,2.048-2.048l8.69,8.69a1.448,1.448,0,0,1,0,2.048l-8.69,8.69A1.444,1.444,0,0,1,25.447,108.275Z"
                                            transform="translate(0 0)" />
                                    </g>
                                </svg>
                            </span>
                        </div>
                        <hr class="hr-1 m-t-30">
                    </div>
                    <div class="form-group m-t-30">
                        <h4 class="main-title">
                            Consignment Details
                        </h4>
                        <div class="row m-t-30">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Cargo Class
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="cargoTypes" [readonly]="readonly" optionLabel="name"
                                        formControlName="cargoclass" placeholder="Select Cargo Type" class="p-dropdown"
                                        (onChange)="getCargoSegment($event)" [filter]="false"></p-dropdown>
                                </div>
                                <!-- <select class="form-control" formControlName="cargoclass"
                                    placeholder="Select Cargo" (change)="getdropdownvalue($event)">
                                    <option value="">--Select Cargo Class --</option>
                                    <option value="1">Auto</option>
                                    <option value="2">Breakbulk</option>
                                    <option value="3">High & Heavy</option>
                                </select> -->
                                <div *ngIf="hasError('cargoclass', 'required') && submitted" class="invalid-Validation">
                                    Cargo Class is required
                                </div>

                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Cargo Segment
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="cargoSegments" [readonly]="readonly" class="p-dropdown"
                                        optionLabel="name" formControlName="cargoconsigment"
                                        placeholder="Select Cargo Segment" [itemSize]="31" [virtualScroll]="true" [filter]="false">
                                    </p-dropdown>
                                </div>
                                <!-- <select class="form-control " placeholder="Select Segment"
                                    formControlName="cargoconsigment" *ngIf="isauto">
                                    <option value="">--Select Segment--</option>
                                    <option value="1">Car (up to 165 cm high)</option>
                                    <option value="2">Car or Van (above 165 cm and up to 215 cm high)</option>
                                    <option value="3">High Van (above 215 cm high)</option>
                                </select> -->
                                <!-- <select class="form-control " formControlName="cargoconsigment"
                                    placeholder="Select Segment" *ngIf="isbreakbulk">
                                    <option value="">&nbsp;</option>

                                    <option value="1">Aviation</option>

                                    <option value="2">Boats and Yachts</option>

                                    <option value="3">Iron and Steel products</option>

                                    <option value="4">Machinery &amp; Machine tools</option>

                                    <option value="5">Masts, Kelly bars or Poles</option>

                                    <option value="6">Masts and/or Keels travelling w Boat or Yacht</option>

                                    <option value="7">Mining and Construction equipment</option>

                                    <option value="8">Oil &amp; Gas Industry</option>

                                    <option value="9">Personal effects travelling with a Car or Van</option>

                                    <option value="10">Power Generation equipment (e.g. transformers, turbines,
                                        generators,
                                        wind power equipment etc)</option>

                                    <option value="11">Rail (e.g. rail cars, locomotives)</option>

                                    <option value="12">Rubber products</option>

                                    <option value="13">Spare parts travelling with High&amp;Heavy rolling units</option>

                                    <option value="14">Other</option>
                                </select>
                                <select class="form-control " formControlName="cargoconsigment"
                                    placeholder="Select Cargo" *ngIf="ishighandhevy">
                                    <option value="">&nbsp;</option>

                                    <option value="1">Agricultural tractors</option>

                                    <option value="2">Boats and Yachts on trailers</option>

                                    <option value="3">Buses</option>

                                    <option value="4">Caravans</option>

                                    <option value="5">Forklifts</option>

                                    <option value="6">Mining and Construction equipment</option>

                                    <option value="7">Mobile Homes</option>

                                    <option value="8">Other Agricultural and Forestry equipment</option>

                                    <option value="9">Other RoRo equipment</option>

                                    <option value="10">Trucks or Truck trailers</option>
                                </select> -->

                                <div *ngIf="hasError('cargoconsigment', 'required') && submitted"
                                    class="invalid-Validation">
                                    Cargo Segment is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Condition
                                </label>
                                <!-- <select class="form-control" formControlName="condition">
                                    <option value="">--Select Condition--</option>
                                    <option value="1">New</option>
                                    <option value="2">Used</option>
                                </select> -->
                                <div class="pRel">
                                    <p-dropdown [options]="cargoConditions" [readonly]="readonly" class="p-dropdown"
                                        optionLabel="viewValue" formControlName="condition"
                                        placeholder="Select Condition" [filter]="false">
                                    </p-dropdown>
                                </div>
                                <div *ngIf="hasError('condition', 'required') && submitted" class="invalid-Validation">
                                    Condition is required
                                </div>
                            </div>

                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Cargo Movement Status
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="cargoMovementStatusList" [readonly]="readonly" class="p-dropdown"
                                        optionLabel="name" formControlName="cargoMovementStatus"
                                        placeholder="Select Movement Status" [filter]="false">
                                    </p-dropdown>
                                </div>
                                <div *ngIf="hasError('cargoMovementStatus', 'required') && submitted" class="invalid-Validation">
                                    Cargo movement status is required
                                </div>
                            </div>

                        </div>
                        <div class="row m-t-30">
                            <!-- <div class="col-md-4 form-group">
                            <label class="custom-labal">
                                Cargo Type
                            </label>
                            <select class="form-control">
                                <option>Select</option>
                            </select>
                        </div> -->
                        
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    When can cargo be in loadport?
                                </label>
                                <div class="">
                                    <p-calendar [readonlyInput]="true" formControlName="whencancargolanport"
                                        showIcon="true" showButtonBar="true" placeholder="Date" [minDate]="minDate"
                                        [monthNavigator]="true" [yearNavigator]="true" yearRange="{{rageYears}}"
                                        icon="pi pi-calendar" iconPos="left" dateFormat="dd-MM-yy">
                                    </p-calendar>

                                </div>
                                <div *ngIf="hasError('whencancargolanport', 'required') && submitted"
                                    class="invalid-Validation">
                                    When can cargo be in loadport? is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Number of Units
                                </label>
                                <input type="number" class="form-control" formControlName="noofunits" placeholder="0"
                                    step="1" (change)="FixedNumber()">
                                <div *ngIf="hasError('noofunits', 'required') && submitted" class="invalid-Validation">
                                    No Of Units is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Shipping Lines (Do not select if you want to keep open)
                                </label>
                                <div class="pRel">
                                    <p-dropdown [options]="shippinglineslist" [readonly]="newReadonly == true?newReadonly: readonly"
                                        formControlName="shippinglineId" class="p-dropdown"
                                        optionLabel="shippingLineName" placeholder="Select ShippingLines"
                                        [filter]="false">
                                    </p-dropdown>
                                </div>
                                <div *ngIf="hasError('condition', 'required') && submitted" class="invalid-Validation">
                                    Condition is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Length(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="length" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="calculateSQM($event,'length')">
                                <div *ngIf="hasError('length', 'required') && submitted" class="invalid-Validation">
                                    Length is required
                                </div>
                                <div *ngIf="lengthvalid" class="invalid-Validation">
                                Length should be less than or Equal to 25
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Width(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="width" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" max (change)="calculateSQM($event,'width')">
                                <div *ngIf="hasError('width', 'required') && submitted" class="invalid-Validation">
                                    Width is required
                                </div>
                                <div *ngIf="widthvalid" class="invalid-Validation">
                                    Width should be less than or Equal to 7
                                    </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Height(m)
                                </label>
                                <input type="textbox" class="form-control" formControlName="height" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" (change)="calulateCBM()">
                                <div *ngIf="hasError('height', 'required') && submitted" class="invalid-Validation">
                                    Height is required
                                </div>
                                <div *ngIf="heightvalid" class="invalid-Validation">
                                    Height should be less than or Equal to 6
                                    </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Weight(mt)
                                </label>
                                <input type="textbox" formControlName="weight" class="form-control" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$">
                                <div *ngIf="hasError('weight', 'required') && submitted" class="invalid-Validation">
                                    Weight is required
                                </div>
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Sqm(m2)
                                </label>
                                <input type="textbox" formControlName="Sqm" class="form-control" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" readonly>
                                <div *ngIf="hasError('Sqm', 'required') && submitted" class="invalid-Validation">
                                    Sqm is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Cbm(m3)
                                </label>
                                <input type="textbox" class="form-control" formControlName="cbm" placeholder="0.00"
                                    name="my_field" pattern="^-?\d*(\.\d{0,2})?$" readonly>
                                <div *ngIf="hasError('cbm', 'required') && submitted" class="invalid-Validation">
                                    Cbm is required
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <div class="row">
                            <div class="col-md-4 form-group">
                                <label class="custom-labal">
                                    <span> Package And Description</span>(Car & H&H: make,model manufacture
                                    year,self-propelled.Break Bulk: Packging Description)
                                </label>
                                <textarea rows="1" pInputTextarea autoResize="autoResize" maxlength="250" formControlName="description" class="form-control"
                                    (keyup)="onKeyPress()" placeholder="Description">
                                </textarea>
                                <div class="font-12 mt-2">
                                    <span *ngIf="descriptionLength == false">Total characters: {{totalChar}}</span>
                                    <span *ngIf="descriptionLength == true">Remaining characters: {{totalChar}}</span>
                                </div>
                                <div *ngIf="hasError('description', 'required') && submitted"
                                    class="invalid-Validation">
                                    Package and Description is required
                                </div>
                            </div>

                            <div class="col-md-6 form-group ">
                                <label class="custom-labal">
                                    <span> Pictures , drawings  or packing lists.</span>
                                    (pdf and images allowed.)
                                </label>
                                <div class="pRel">
                                    <span *ngFor="let item of fileNames"> 
                                        <a href="{{downloadBaseUrl}}{{item}}"><img src="../../../assets/images/fileicon.png" /></a>
                                    </span>
                                </div>
                                <div class="pRel uploadfile">
                                    <ngx-file-drop  dropZoneLabel="Drop files here" (onFileDrop)="onFileDropped($event)"
                                        (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)" multiple="false">
                                        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                            <i class="fa fa-upload"></i><br />
                                            <button type="button" (click)="openFileSelector()">Drag and Drop or Select File</button>
                                        </ng-template>
                                    </ngx-file-drop>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="form-group m-t-30">
                        <h4 class="main-title">
                            User Details
                        </h4>
                        <div class="row m-t-30">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Phone Number
                                </label>
                                <div class="pRel">
                                    <input type="text" formControlName="phoneNumber" maxLength="12" class="form-control"
                                        placeholder="Phone Number">
                                    <div *ngIf="hasError('phoneNumber', 'required') && submitted"
                                        class="invalid-Validation">
                                        Phone Number is required
                                    </div>
                                </div>                             
                            </div>
                            <ng-container *ngIf="!showUserDetails">
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Email
                                </label>
                                <div class="pRel">
                                    <input type="text" formControlName="email" class="form-control"
                                        placeholder="Email">
                                    <div *ngIf="hasError('email', 'required') && submitted"
                                        class="invalid-Validation">
                                        Email is required
                                    </div>
                                </div>                             
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    First Name
                                </label>
                                <div class="pRel">
                                    <input type="text" formControlName="firstname" class="form-control"
                                        placeholder="First Name">
                                    <div *ngIf="hasError('phoneNumber', 'required') && submitted"
                                        class="invalid-Validation">
                                        First Name is required
                                    </div>
                                </div>                             
                            </div>
                            <div class="col-md-3 form-group">
                                <label class="custom-labal">
                                    Last Name
                                </label>
                                <div class="pRel">
                                    <input type="text" formControlName="lastname" class="form-control"
                                        placeholder="Last Name">
                                    <div *ngIf="hasError('lastname', 'required') && submitted"
                                        class="invalid-Validation">
                                        Last Name is required
                                    </div>
                                </div>                             
                            </div>
                            </ng-container>
                        </div>                        
                    </div>
                    <div class="form-group">
                        <div class="row">
                            <div class="col-md-12 text-end mb-3">
                                <button class="btn  btn-signIn" routerLink="/raterequestlist">
                                    Back To List
                                </button> &nbsp;
                                <button class="btn  btn-signIn" type="submit">
                                    SUBMIT
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

        </div>
    </div>
</section>